import { render, staticRenderFns } from "./TypeDocumentEdit.vue?vue&type=template&id=eeb5e414&scoped=true"
import script from "./TypeDocumentEdit.vue?vue&type=script&lang=js"
export * from "./TypeDocumentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb5e414",
  null
  
)

export default component.exports